import Inline from './Inline'

/* istanbul ignore next */
Inline.install = function (Vue) {
  Vue.component(Inline.name, Inline)
}

export default Inline
